import { render, staticRenderFns } from "./SummaryGVS.vue?vue&type=template&id=1cb7dd5e"
import script from "./SummaryGVS.vue?vue&type=script&lang=js"
export * from "./SummaryGVS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports